import script from "./employees-list.vue?vue&type=script&setup=true&lang=js"
export * from "./employees-list.vue?vue&type=script&setup=true&lang=js"

import "./employees-list.vue?vue&type=style&index=0&id=80cb7c9e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-80cb7c9e"]])

export default __exports__